import { Component, OnInit, Input } from '@angular/core';

import { ErrorService } from '../../services/error.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { NerService } from '../../services/ner.service';

@Component({
  selector: 'ner-output',
  templateUrl: './ner-output.component.html'
})
export class NerOutputComponent implements OnInit {

  nerData: any = null;
  type: string = 'summary';

  private h: any = {
    summaryNames: false,
    summaryEmail: false,
    summaryPhone: false,
    summaryTitle: false,
    summaryDates: false,
    summaryGeography: false
  };

  @Input()
  set data(data: any) {
    this.nerData = data;
    this.updateView();
  }

  constructor(private nerService: NerService,
              private errorService: ErrorService,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
  }

  addTerm(type: string, term: string) {
    this.nerService.addTermFromTest(type, term).subscribe(
      (result: any) => {
        this.globalMessageService.message('Term was added');
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'ner-output.component', 'addTerm');
      }
    )
  }

  removeTerm(type: string, term: string) {
    this.nerService.deleteTermFromTest(type, term).subscribe(
      (result: any) => {
        this.globalMessageService.message('Term was removed');
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'ner-output.component', 'removeTerm');
      }
    )
  }

  updateView() {
    if (this.nerData.names) {
      this.nerData.names.sort((a,b) => {
        return a.index > b.index
      });

      this.nerData.email_addresses.sort((a,b) => {
        return a.index > b.index
      });

      this.nerData.phone_numbers.sort((a,b) => {
        return a.index > b.index
      });

      this.nerData.titles.sort((a,b) => {
        return a.index > b.index
      });

      this.nerData.dates.sort((a,b) => {
        return a.index > b.index
      });

      this.nerData.cities.sort((a,b) => {
        return a.index > b.index
      });

      this.nerData.verbose.raw_names.inspected.sort((a,b) => {
        if (a.fn_found && a.ln_found) {
          if (!b.fn_found || !b.ln_found || b.fn_stop || b.ln_stop) {
            return -1;
          }
          else {
            return 1;
          }
        }
        else if (a.fn_found || a.ln_found) {
          if (b.fn_found && b.ln_found) {
            return 1;
          }
          else {
            return -1;
          }
        }
        else if (!a.fn_stop && !a.ln_stop) {
          if (b.fn_found || b.ln_found) {
            return 1;
          }
          else {
            return -1;
          }
        }
        // else if (!a.fn_stop || !a.ln_stop) {
        //   if (!b.fn_stop && !b.ln_stop) {
        //     return 1;
        //   }
        //   else {
        //     return -1;
        //   }
        // }
        else {
          // a is bad
          return 1;
        }
      });

      this.nerData.verbose.phone_numbers.sort((a,b) => {
        return a.index > b.index;
      });

      this.nerData.verbose.possible_titles.sort((a,b) => {
        return a.index > b.index;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/ner-output/ner-output.component.ts